import { REFRESH_GEOFENCES, UPDATE_GEOFENCES } from '../constants';

const DEFAULT_STATE = {
  geofences: {},
};

const GeofencesReducer = (state = DEFAULT_STATE, { type, payload }) => {
  switch (type) {
    case REFRESH_GEOFENCES:
      state.geofences = {};
      payload.forEach((geofence) => (state.geofences[geofence.id] = geofence));
      return {
        ...state,
      };
    case UPDATE_GEOFENCES:
      payload.forEach((geofence) => (state.geofences[geofence.id] = geofence));
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default GeofencesReducer;
